import { render, staticRenderFns } from "./CloseForm.vue?vue&type=template&id=de4c60a4&scoped=true"
import script from "./CloseForm.vue?vue&type=script&lang=js"
export * from "./CloseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4c60a4",
  null
  
)

export default component.exports